export enum ErrorCodes {
  ApplicationCrash,
  Custom,
  Conflict,
  DataValidation,
  Forbidden,
  NotFound,
  RateLimit,
  ResetPassword,
  ResourceDependency,
  ServerCommunication,
  Unknown,
  InvalidValidation,
  CompanyInvalidData,
  RequestCanceled,
  WeakPassword,
  CompromisedPassword
}

export enum MetaErrorCodes {
  ClosedStore,
  Empty,
  ExpectedValue,
  Forbidden,
  Inactive,
  LimitExceeded,
  Minimum,
  NeedAnotherField,
  NotFound,
  RegistryLimitExceeded,
  Unique,
  Unknown,
  WrongFormat,
  WrongValue,
  ProductCategoryParentRule,
  DuplicateValue,
  CheckPasswordRule,
  CheckAdministratorProfileRule,
  In,
  CannotUpload,
  CertificateDate,
  CertificatePassword,
  CertificateDocument,
  CertificatePrivateKey,
  AlreadyExists,
  GroupIcmsNotBelongsToCompany,
  GroupIpiNotBelongsToCompany,
  GroupPisCofinsNotBelongsToCompany
}

export type Meta = { [key: string]: MetaErrorCodes | any }

export interface BaseError {
  code: ErrorCodes
  message?: string
  meta?: Meta
}
